// extracted by mini-css-extract-plugin
export default {"Categories":"Categories_Categories__k98Wx"};